module.exports = __webpack_public_path__ + "static/media/traditional-folk-band.d77fafd5.jpg";